var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isVisible)?_c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"loading"},[_c('img',{staticClass:"loading-player",attrs:{"src":require("@/assets/images/gv-oedu@3x.png")}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }